import qs from "qs";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const RedirectLogin = () => {
  const { search } = useLocation();

  const { handleLogin } = useAuth();

  const query = qs.parse(search, { ignoreQueryPrefix: true });
  useEffect(
    () => {
      if (query.tk) {
        handleLogin(query);
      } else {
        window.location.replace(String(process.env.REACT_APP_LOGIN_URL) + '/?error=true')
      }
    },
    // eslint-disable-next-line
    [, handleLogin]
  );

  return <></>;
};

export default RedirectLogin;
